import React, { useEffect, useState } from 'react'
import { updateCourseDocumentIsPublic } from '../utils/Network'

export default function CourseDocumentPublicButton({ coursedocument, callback }) {

    const [is_public, setPublic] = useState(null)

    useEffect(() => {
        if (coursedocument) {
            setPublic(coursedocument.public)
        }
    }, [coursedocument])

    const updateIsPublic = (e) => {
        e?.preventDefault?.()
        e?.stopPropagation?.()
        if (!coursedocument?.id) return
        updateCourseDocumentIsPublic(coursedocument.id, !is_public).then(() => {
            setPublic(!is_public)
        })
    }

    if (!coursedocument?.id) {
        return null
    }

    return (
        <div title={`${is_public ? "Audience can vote for this document" : "Not visible to Audience"}`} style={{ padding: 5 }} onClick={updateIsPublic}>
            <i className={`fa fa-users ${is_public ? "color-success" : "color-warning"}`}></i>
        </div>

    )
}
